import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["row", "bubble", "leftAvatar", "rightAvatar"]

  connect() {
    this.updateMessageOwnership()
    this.updateMenuVisibility()
  }

  updateMessageOwnership() {
    const messageUserId = this.element.dataset.messageUserId
    // Get current user ID from the page body data attribute or from the message element
    const currentUserId = this.element.dataset.currentUserId || 
      document.querySelector('[data-current-user-id]')?.dataset.currentUserId
    
    if (messageUserId && currentUserId && messageUserId === currentUserId) {
      this.styleAsOwnerMessage()
    } else {
      this.styleAsOtherMessage()
    }
  }

  updateMenuVisibility() {
    const messageUserId = this.element.dataset.messageUserId
    const currentUserId = this.element.dataset.currentUserId || 
      document.querySelector('[data-current-user-id]')?.dataset.currentUserId
    
    const menu = this.element.querySelector('[data-message-menu]')
    if (menu) {
      if (messageUserId && currentUserId && messageUserId === currentUserId) {
        menu.style.display = 'block'
      } else {
        menu.style.display = 'none'
      }
    }
  }

  styleAsOwnerMessage() {
    // Style as owner message (right-aligned)
    if (this.hasRowTarget) this.rowTarget.classList.add('justify-content-end')
    if (this.hasBubbleTarget) this.bubbleTarget.classList.add('chat-bubble-me')
    if (this.hasLeftAvatarTarget) this.leftAvatarTarget.style.display = 'none'
    if (this.hasRightAvatarTarget) this.rightAvatarTarget.style.display = 'block'
  }

  styleAsOtherMessage() {
    // Style as other's message (left-aligned)
    if (this.hasRowTarget) this.rowTarget.classList.remove('justify-content-end')
    if (this.hasBubbleTarget) this.bubbleTarget.classList.remove('chat-bubble-me')
    if (this.hasLeftAvatarTarget) this.leftAvatarTarget.style.display = 'block'
    if (this.hasRightAvatarTarget) this.rightAvatarTarget.style.display = 'none'
  }
}
